module.exports = __webpack_public_path__ + "img/theme-6-red.1da6a8df.svg";